interface ArticleSchemaProps {
  title: string;
  excerpt: string;
  image: string;
  date: string;
  updatedDate: string;
  author: string;
  category: string;
  url: string;
}

export default function ArticleSchema({
  title,
  excerpt,
  image,
  date,
  updatedDate,
  author,
  category,
  url,
}: ArticleSchemaProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description: excerpt,
    image: image,
    datePublished: date,
    dateModified: updatedDate,
    author: {
      "@type": "Person",
      name: author,
    },
    publisher: {
      "@type": "Organization",
      name: "黑料网",
      logo: {
        "@type": "ImageObject",
        url: "https://readdy.ai/api/search-image?query=Minimalist%20flame%20logo%20icon%2C%20clean%20geometric%20design%2C%20warm%20amber%20orange%20color%2C%20dark%20background%2C%20modern%20app%20icon%20style%2C%20simple%20bold%20shape%2C%20high%20contrast&width=120&height=120&seq=logo-schema&orientation=squarish",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    articleSection: category,
    wordCount: excerpt.length,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}